module.exports = __webpack_public_path__ + "static/img/thirdBox.884c214.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thirdBox.png
// module id = 3uvl
// module chunks = 1